import React from 'react';
import { Theme } from '../../Enums/Theme.enum';
import LinkButton from './LinkButton';
// @ts-ignore
import styles from './Buttons.module.scss';

interface Props {
	onClick: () => void;
	title?: string;
}

const BackButton: React.FC<Props> = ({
	onClick,
	title = 'base.shared.back',
}) => {
	return (
		<div className={styles.attachmentButton}>
			<img
				className={styles.icon}
				src={'/dist/icons/chevron-left-backgrounded.svg'}
				alt={'backarrow'}
			/>
			<LinkButton onClick={onClick} title={title} theme={Theme.BLUE} />
		</div>
	);
};

export default BackButton;
